import { Text } from '@user-portal/wikr-components';
import React from 'react';
import { Trans } from 'react-i18next';

import { getCurrencySign, getPriceForCurrency } from 'helpers/prices';

import { Cross, MoveBack } from 'components/Icon';
import Modal from 'components/Modal';

import DiscountOffer from '../../DiscountOffer';

import { IDiscountOfferModal } from './types';

import * as S from './styled';

const DiscountOfferModal = ({
    onSubmit,
    onDiscard,
    onClose,
    trackLoad,
    captions,
    onMoveBack,
    oldProduct,
    specialOfferProduct,
    discount,
    isCurrentSubscriptionMain,
}: IDiscountOfferModal) => {
    const {
        title,
        headerTitle,
        firstBadgeText,
        secondBadgeText,
        subTitle,
        extraText,
        submitButton,
        discardButton,
        additionalInfo,
        period,
        periodTitle,
        bottomDisclaimer,
    } = captions;

    const handleDiscard = () => {
        onDiscard && onDiscard();
    };

    const handleSubmit = () => {
        onSubmit();
    };

    return (
        <Modal
            paddingX={0}
            paddingY={0}
            isOpen
            onClose={onClose}
            transparentOverlay={false}
            transparentBackground
            trackLoad={trackLoad}
            contentAlignmentY="top"
        >
            <S.SurveyContent data-locator="discountOfferContainer">
                <S.ModalHeaderTitle>
                    {onMoveBack && (
                        <S.IconWrapper
                            onClick={onMoveBack}
                            data-testid="cancelSubscriptionModalBackButton"
                            data-locator="cancelSubscriptionModalBackButton"
                        >
                            <MoveBack />
                        </S.IconWrapper>
                    )}
                    <S.TitleText>
                        <Text type="large-text" medium>
                            {headerTitle}
                        </Text>
                    </S.TitleText>
                    <S.IconWrapper
                        onClick={onClose}
                        data-testid="cancelSubscriptionModalCloseButton"
                        data-locator="cancelSubscriptionModalCloseButton"
                    >
                        <Cross />
                    </S.IconWrapper>
                </S.ModalHeaderTitle>
                <S.DiscountsContainer>
                    {additionalInfo && (
                        <S.SubscriptionAdditionalInfo>
                            <Text mb={8}>{additionalInfo?.title}</Text>
                            <Text color="text-secondary">{additionalInfo?.text}</Text>
                        </S.SubscriptionAdditionalInfo>
                    )}
                    <Text type="h4" medium center mb={12}>
                        <Trans i18nKey={title} values={{ discount }} components={{ Primary: <span /> }} />
                    </Text>

                    {subTitle && (
                        <Text type="large-text" center mb={24}>
                            {subTitle}
                        </Text>
                    )}

                    {isCurrentSubscriptionMain && (
                        <DiscountOffer
                            badgeBackgroundColor="surface-hovered"
                            badgeText={firstBadgeText}
                            price={oldProduct.price}
                            period={period}
                            periodTitle={periodTitle}
                            currencySign={getCurrencySign(oldProduct.currency)}
                        />
                    )}
                    <DiscountOffer
                        badgeBackgroundColor="critical-default"
                        badgeText={secondBadgeText}
                        extraText={extraText}
                        oldPrice={oldProduct.price}
                        price={getPriceForCurrency(specialOfferProduct)}
                        period={period}
                        periodTitle={periodTitle}
                        currencySign={getCurrencySign(specialOfferProduct.currency)}
                        isNewOffer
                        handleSubmit={handleSubmit}
                        submitButton={submitButton}
                        isCurrentSubscriptionMain={isCurrentSubscriptionMain}
                    />
                </S.DiscountsContainer>

                {discardButton && (
                    <S.ConfirmButton
                        dataLocator="keepSubBtn"
                        size="medium"
                        textColor="action-main"
                        onClick={handleDiscard}
                    >
                        {discardButton}
                    </S.ConfirmButton>
                )}
                <S.Disclaimer>
                    <Text type="caption" color="text-secondary-subdued">
                        {bottomDisclaimer}
                    </Text>
                </S.Disclaimer>
            </S.SurveyContent>
        </Modal>
    );
};

export default DiscountOfferModal;
